import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { logout } from "@newsenec/auth-provider";
import { SenecScreenTemplate } from "../SenecScreenTemplate";
import { SenecButton } from "@newsenec/ui-components";

export const RegistrationSuccess = () => {
    const { t } = useTranslation();
    return (
        <SenecScreenTemplate
            title={t("registrationScreen.RegistrationSuccess")}
            content={
                <>
                    <img src="/handshake-icon.png" alt="Handshake icon" height="100px"></img>
                    <SenecButton level="primary" onClick={async () => logout()}>
                        {t("registrationScreenContinueToFPP")}
                    </SenecButton>
                </>
            }
            footer={<Typography>{t("registrationScreen.RegistrationSuccess.relogin")}</Typography>}
        />
    );
};
